/**
 * External Imports
 */
import styled from 'styled-components';

export const DateRangeSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  margin-top: -20px;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.875rem;
  line-height: 22px;
`;

export const Range = styled.div``;

export const StartEnd = styled.div`
  display: flex;
`;

export const SelectContainer = styled.div``;
